import { Spinner } from 'ui/spinner';
import { PreviewWrapper } from './TemplateContent.styles';

export const TEMPLATE_PREVIEW_TEST_ID = 'template-loading-test-id';
export const TEMPLATE_PREVIEW_SPINNER_TEST_ID = 'template-preview-spinner-test-id';

export const TemplateLoading = () => {
  return (
    <PreviewWrapper data-test={TEMPLATE_PREVIEW_TEST_ID}>
      <Spinner data-test={TEMPLATE_PREVIEW_SPINNER_TEST_ID} />
    </PreviewWrapper>
  );
};
